import { Layout } from 'components/layout'
import { PgWithControls } from 'components/pg-with-controls'
// import { TmCoachAdPopup } from 'components/tm-coach-ad-popup'
import { LESSON_NAMES } from 'constants/lessons'
import { PG } from 'constants/pg'
import { useLoadInitialData } from 'hooks/database/use-load-initial-data'
import { useLoadStats } from 'hooks/database/use-load-stats'
import { setLocalStoreLessonRules } from 'local-store/lesson'
import { useRouter } from 'next/router'
import { useAuthUser } from 'next-firebase-auth'
import { useEffect } from 'react'
import { conditionalProp } from 'utils/conditional-prop'
import { urlWithSiteOrigin } from 'utils/url-with-site-origin'

export const TypingPractice = () => {
  useLoadInitialData()
  useLoadStats()

  const authUser = useAuthUser()
  const authLoading = !authUser.clientInitialized
  const router = useRouter()
  const urlDuration = router.query.duration
  const urlLesson = router.query.lesson as string | undefined

  // Handle URL lesson parameter and set in local storage if valid
  useEffect(() => {
    if (urlLesson) {
      // Validate that the lesson name is valid
      const isValidLesson = Object.values(LESSON_NAMES).includes(urlLesson as LESSON_NAMES)

      if (isValidLesson) {
        // Set the lesson in local storage
        setLocalStoreLessonRules({
          pageRoute: '/typing-practice/',
          rules: { lessonName: urlLesson as LESSON_NAMES },
        })
      }
    }
  }, [urlLesson])

  return (
    <Layout
      authLoading={authLoading}
      uid={authUser.id}
      signOut={authUser.signOut}
      seoProps={{
        title: 'Typing Practice - Join Free with 100000+ Users Worldwide',
        description: `Improve your touch typing speed by typing practice with these 35+ unique free lessons. Get accurate results in WPM, and KPH with stats tracking. Start Now Free!`,
        canonicalUrl: urlWithSiteOrigin('/typing-practice/'),
        pageUrl: urlWithSiteOrigin('/typing-practice/'),
      }}
    >
      <PgWithControls
        isTypingPracticePage
        pgName={PG.MAIN_PG}
        defaultRules={{
          lessonName:
            urlLesson && Object.values(LESSON_NAMES).includes(urlLesson as LESSON_NAMES)
              ? (urlLesson as LESSON_NAMES)
              : 'PARAGRAPH',
          // keep the functionality to set duration from url for cypress
          ...conditionalProp(!!urlDuration, 'duration', urlDuration),
        }}
      />
      {/* <TmCoachAdPopup /> */}
    </Layout>
  )
}
